import { h } from '@stencil/core/internal/client';

const MediaCardContainer = (_, children) => (h("div", { class: "media-card-container" }, children));

export { MediaCardContainer as M };
